import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Animations
// Common
import { AngularMaterialService, ErrorParseService, IOverrideReporting, LGEDataService } from '../../commons';
// State
import { Store } from '@ngrx/store';

import * as fromOverrideReporting from './state/override-reporting.selectors';
import * as OverrideReportingAction from './state/override-reporting.actions';
import * as lgeApp from '../../app/state/app.actions';
import * as _ from 'lodash';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable, skipWhile, Subscription } from 'rxjs';
import { slideInDownAnimation } from 'src/app/app.animation';

@Component({
    selector: 'override-reporting-screen',
    templateUrl: 'override-reporting.component.html',
    styleUrls: ['override-reporting.scss'],
    animations: [slideInDownAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverrideReportingScreenComponent implements OnInit, OnDestroy {
    @Input() pending$: Observable<boolean>;
    pendingSubscription: Subscription;
    pending: boolean;
    @Input() error$: Observable<string | null>;
    errorSubscription: Subscription;
    error: string | null;
    @Input() stateData$: Observable<IOverrideReporting | null>;
    stateDataSubscription: Subscription;
    stateData: IOverrideReporting | null;

    employeeInfo: FormGroup;
    overrideReporting: FormGroup;
    isLoadingResults = false;
    isLoading = false;

    employeeList = [];
    MGList = [];
    SM_ECList = [];
    ECList = [];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    displayedColumns = ['EmpId', 'FirstName', 'LastName', 'DepartmentName', 'Email', 'Title', 'managerCC', 'managerCA', 'director', 'VP_CR_CA', 'LOB_VP1', 'LOB_VP2', 'CP_CEO'];
    dataSource: MatTableDataSource<any>;

    employeeData: any;

    constructor(
        private store: Store<fromOverrideReporting.State>,
        private ref: ChangeDetectorRef,
        private fb: FormBuilder,
        private ams: AngularMaterialService,
        private _dataService: LGEDataService,
        private errorParse: ErrorParseService
    ) {
        this.selectState();
        this.createForms();
        this.dataSource = new MatTableDataSource([]);
    }

    ngOnInit() {
        this.startSubscriptions();
        this.GetOverrideUserDetail();
        this.GetLGEEmployees();
    }

    GetOverrideUserDetail() {
        this.isLoadingResults = true;
        this._dataService.GetOverrideUserDetail()
            .subscribe({
                next: data => {
                    // console.log(data);
                    this.isLoadingResults = false;
                    this.dataSource = new MatTableDataSource(data);
                    this.sortFilterPagination();
                    this.ref.markForCheck();
                }, error: error => {
                    // console.log('GetOverrideUserDetail: ', error);
                    this.isLoadingResults = false;
                    this.ams.showAlert('Error!', error);
                }
            })
    }

    GetLGEEmployees() {
        this.isLoading = true;
        this._dataService.GetLGEEmployees().
            subscribe({
                next: data => {
                    // console.log(data);
                    this.isLoading = false;
                    this.employeeList = data;

                    this.MGList = _.sortBy((this.employeeList.filter(employee => employee.EmpType == 'MG')), 'EmpName');
                    // console.log('MGList: ', this.MGList)

                    this.SM_ECList = _.sortBy((this.employeeList.filter(employee => ((employee.EmpType == 'EC') || (employee.EmpType == 'SM')))), 'EmpName');
                    // console.log('SM_ECList: ', this.SM_ECList)

                    this.ECList = _.sortBy((this.employeeList.filter(employee => (employee.EmpType == 'EC'))), 'EmpName');
                    // console.log('ECList: ', this.ECList)

                    this.ref.markForCheck();
                },
                error: error => {
                    // console.log('GetLGEEmployees: ', error);
                    this.isLoading = false;
                    this.ams.showAlert('Error!', error);
                    this.ref.markForCheck();
                }
            })
    }

    selectRow(row) {
        this.ams.showLoader('Loading...');

        this.employeeData = row;
        // console.log(this.employeeData);
        let empData: any = {};
        empData.EmpId = row.EmpId;
        empData.DepartmentName = row.DepartmentName;
        empData.FirstName = row.FirstName;
        empData.LastName = row.LastName;
        empData.Email = row.Email;
        empData.Title = row.Title;
        empData.managerCC = row.managerCC;
        empData.managerCA = row.managerCA;
        empData.director = row.director;
        empData.VP_CR_CA = row.VP_CR_CA;
        empData.LOB_VP1 = row.LOB_VP1;
        empData.LOB_VP2 = row.LOB_VP2;
        empData.CP_CEO = row.CP_CEO;
        empData.orId = row.orId;
        empData.approverLevelId = row.approverLevelId;
        empData.deleteIt = false;

        this.ams.closeDialog();
        this.ams.showOverrideDetails('Override User Details', 'Override user details', empData, this.MGList, this.SM_ECList, this.ECList, true);
        this.ams.override.afterClosed().subscribe(result => {
            if (result) {
                // console.log(result);
                this.ams.showLoader('Loading...');
                this._dataService.OverrideUserDetail(result)
                    .subscribe({
                        next: (response) => {
                            this.ams.closeDialog();
                            if (response === 'Error') {
                                this.ams.showAlert('Error!', 'please try again!');
                            } else {
                                if (result.deleteIt === true) {
                                    this.ams.showAlert('Success!', 'Successfully deleted!');
                                } else {
                                    this.ams.showAlert('Success!', 'Successfully Updated!');
                                }
                                // ws call to get all override
                                this.isLoadingResults = true;
                                this._dataService.GetOverrideUserDetail().subscribe({
                                    next: data => {
                                        this.isLoadingResults = false;
                                        this.dataSource = new MatTableDataSource(data);
                                        this.sortFilterPagination();
                                        this.ref.markForCheck();
                                        this.createForms();
                                    }, error: error => {
                                        // console.log(error);
                                        this.ams.showAlert('Error!', error);
                                        this.isLoadingResults = false;
                                        this.ref.markForCheck();
                                    }
                                })
                            }
                        }
                    })
            }
        })
    }

    onSubmit() {
        this.ams.showLoader('Loading...');
        this._dataService.getEmployeeByEmpId(this.employeeInfo.value)
            .subscribe({
                next: data => {
                    // console.log('Employee Info');
                    // console.log(data);
                    this.employeeData = data;
                    let empData: any = {};
                    empData.EmpId = data.EmpId;
                    empData.DepartmentName = data.DepartmentName;
                    empData.FirstName = data.FirstName;
                    empData.LastName = data.LastName;
                    empData.Email = data.Email;
                    empData.Title = data.Title;

                    empData.managerCC = '';
                    empData.managerCA = '';
                    empData.director = '';
                    empData.VP_CR_CA = '';
                    empData.LOB_VP1 = '';
                    empData.LOB_VP2 = '';
                    empData.CP_CEO = '';
                    empData.orId = null;
                    empData.approverLevelId = null;
                    empData.deleteIt = false;

                    this.ams.closeDialog();
                    this.ams.showOverrideDetails('Override User Details', 'Override user details', empData, this.MGList, this.SM_ECList, this.ECList, false);
                    this.ams.override.afterClosed().subscribe(result => {

                        if (result) {
                            this.ams.showLoader('Loading...');
                            this._dataService.OverrideUserDetail(result)
                                .subscribe({
                                    next: (response) => {
                                        this.ams.closeDialog();
                                        if (response === 'Error') {
                                            this.ams.showAlert('Error!', 'please try again!');
                                            this.isLoadingResults = false;
                                        } else if (response === 'duplicate') {
                                            this.ams.showAlert('Error!', 'Record already exist!');
                                            this.isLoadingResults = false;
                                        } else {
                                            this.ams.showAlert('Success!', 'Successfully submitted!');
                                            // ws call to get all override
                                            this.isLoadingResults = true;
                                            this._dataService.GetOverrideUserDetail()
                                                .subscribe({
                                                    next: data => {
                                                        this.isLoadingResults = false;
                                                        this.dataSource = new MatTableDataSource(data);
                                                        this.sortFilterPagination();
                                                        this.ref.markForCheck();
                                                        this.createForms();
                                                    },
                                                    error: error => {
                                                        // console.log(error);
                                                        this.ams.showAlert('Error!', error);
                                                        this.isLoadingResults = false;
                                                        this.ref.markForCheck();
                                                    }
                                                });
                                        }
                                    }
                                })
                        }
                    })

                }, error: error => {
                    // console.log(error);
                    this.ams.showAlert('Error!', `Please try again later! \n Details:${JSON.stringify(error)}`);
                }
            })
    }

    onSubmitTest() {
        let empData: any = {};

        empData.EmpId = '';
        empData.DepartmentName = '';
        empData.FirstName = '';
        empData.LastName = '';
        empData.Email = '';
        empData.Title = '';

        empData.managerCC = '--';
        empData.managerCA = '--';
        empData.director = '--';
        empData.VP_CR_CA = '--';
        empData.LOB_VP1 = '--';
        empData.LOB_VP2 = '--';
        empData.CP_CEO = '--';
        empData.orId = null;
        empData.approverLevelId = null;
        empData.deleteIt = false;

        this.ams.closeDialog();
        this.ams.showOverrideDetails('Override User Details', 'Override user details', empData, this.MGList, this.SM_ECList, this.ECList, false);
        this.ams.override.afterClosed().subscribe(result => {
            // console.log('Override User Details: ', result);
        })


    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }

    // Select state
    selectState(): void {
        this.pending$ = this.store.select(fromOverrideReporting.getOverrideReportingScreenPending);
        this.stateData$ = this.store.select(fromOverrideReporting.getOverrideReportingState);
        this.error$ = this.store.select(fromOverrideReporting.getOverrideReportingScreenError).pipe(skipWhile(error => error === undefined || error === null || error === ''));
    }

    displayLoader(pending: boolean): void {
        if (pending) {
            this.ams.showLoader("Loading");
        } else {
            this.ams.closeDialog().then(() => {
                if (this.error !== null && this.error !== undefined && this.error !== '') {
                    this.displayError(this.error);
                }
            });
        }
    }

    displayError(error: any): void {
        let errorMessage;
        if (this.errorParse.foundKeyWord(error, "CORPCOMMONWS")) {
            errorMessage = this.errorParse.translateCCError(error);
        } else {
            errorMessage = error instanceof Object ? error.message : error;
        }
        this.ams.showAlert("Loading Error", errorMessage);
        this.ams.alert.afterClosed().subscribe(result => {
            this.store.dispatch(new OverrideReportingAction.OverrideReportingScreenErrorReset());
        });
    }

    // Create reactive forms
    createForms(): void {
        this.employeeInfo = this.fb.group({
            'EmpId': ['']
            // 'EmpId': ['', Validators.pattern(new RegExp(/^[enEN][0-9]{6}$/))]
        });
    }

    // Opens sidenav if on mobile
    public openSidenav(): void {
        this.store.dispatch(new lgeApp.OpenSidenav());
    }
    // Subscribe to state data and mark it for changes
    startSubscriptions(): void {
        this.pendingSubscription = this.pending$
            .subscribe(data => {
                this.pending = data;
                this.displayLoader(this.pending);
                this.ref.markForCheck();
            });
        this.errorSubscription = this.error$
            .subscribe(data => {
                this.error = data;
                this.ref.markForCheck();
            });
        this.stateDataSubscription = this.stateData$
            .subscribe(data => {
                this.stateData = data;
                this.ref.markForCheck();
            });
    }



    sortFilterPagination() {

        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                default: return item[property];
            }
        };

        this.dataSource.filterPredicate = (data, filter: string) => {
            const accumulator = (currentTerm, key) => {
                return currentTerm + data[key];
            };
            const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
            // Transform the filter by converting it to lowercase and removing whitespace.
            const transformedFilter = filter.trim().toLowerCase();
            return dataStr.indexOf(transformedFilter) !== -1;
        };

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    // Unsubscribe from state data changes
    endSubscriptions(): void {
        this.pendingSubscription.unsubscribe();
        this.errorSubscription.unsubscribe();
        this.stateDataSubscription.unsubscribe();
    }

    ngOnDestroy() {
        this.endSubscriptions();
    }
}